import { Controller } from '@hotwired/stimulus';

/**
 * Timezone - fills a hidden field with the browser's IANA time zone (e.g. Europe/Lisbon).
 * @example <input type="hidden" name="user[time_zone]" data-controller="timezone">
 */
export default class extends Controller {
  connect () {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zone) this.element.value = zone;
  }
}
